import { TreasuryPage } from '@/pages/treasury/treasury-page';
import { TPPAdapters } from '@seapoint/server/enums';
import { Navigate, Route, Routes, useLocation, useParams } from 'react-router';
import AccountsPage from '../pages/accounts/accounts-page';
import { AccountsRoutesWrapper } from '../pages/accounts/sections/accounts-routes-wrapper';
import { ConnectedAccountsPageWrapper } from '../pages/accounts/sections/connected-accounts-page.tsx/connected-account-page-wrapper';
import { OpenAccountPage } from '../pages/accounts/sections/open-account-page/open-account-page';
import { OpenBankingPageWrapper } from '../pages/accounts/sections/open-banking-page/connect-open-banking-page-wrapper';
import { CardsTestPage } from '../pages/cards-test/cards-test-page';
import { CardsPage } from '../pages/cards/cards-page';
import DashboardPage from '../pages/dashboard/dashboard-page';
import { IntegrationsPageWrapper } from '../pages/integrations/integrations-page-wrapper';
import { InvoicePayPageOuterWrapper } from '../pages/invoice-pay/invoice-pay-page-outer-wrapper';
import Layout from '../pages/layout/layout';
import { ManageMembersPage } from '../pages/members/manage-members-page';
import { NoMatch } from '../pages/no-match/no-match';
import { PaymentsPage } from '../pages/payments/payments-page';
import { PayrollPage } from '../pages/payroll/payroll-page';
import { ReachoutPage } from '../pages/reachout/reachout';
import ReportingPage from '../pages/reporting/reporting-page';
import OrganisationSettingsPage from '../pages/settings/organisation-settings';
import CreateCompany from '../pages/signup/create-company';
import { SignupPage } from '../pages/signup/signup-page';
import VerifyEmail from '../pages/signup/verify-email';
import { TPPConsentPage } from '../pages/tpp/consent-page';
import ConsentResultPage from '../pages/tpp/consent-result-page';
import TransactionsPage from '../pages/transactions/transactions-page';
import { ProtectedRoute } from './protected-route';

// TODO: This is a temporary component to redirect old /dashboard/* routes to new paths without /dashboard prefix https://linear.app/seapoint/issue/TENG-2999/remove-react-router-redirect
const DashboardRedirect = () => {
  const params = useParams();
  const location = useLocation();
  const redirectPath = params['*'] ? `/${params['*']}` : '/transactions';
  return <Navigate to={redirectPath + location.search + location.hash} replace />;
};

export const AppRoutes = () => {
  return (
    <Routes>
      {/* Protected signup routes */}
      <Route path="/signup" element={<ProtectedRoute element={<SignupPage />} requiresCompleteSignup={false} />}>
        <Route path="verifyemail" element={<VerifyEmail />} />
        <Route path="organisation" element={<CreateCompany />} />
      </Route>

      {/* Protected app routes */}
      <Route element={<ProtectedRoute element={<Layout />} />}>
        <Route path="/dashboard" element={<DashboardPage />} />
        <Route path="/transactions" element={<TransactionsPage />} />
        <Route path="/accounts" element={<AccountsPage />}>
          <Route index element={<AccountsRoutesWrapper />} />
          <Route path="open-seapoint-account" element={<OpenAccountPage />} />
          <Route path="connect-open-banking" element={<OpenBankingPageWrapper />} />
          <Route path="connected-accounts" element={<ConnectedAccountsPageWrapper />} />
        </Route>
        <Route path="/treasury" element={<TreasuryPage />} />
        <Route path="/payments" element={<PaymentsPage />} />
        <Route path="/cards" element={<CardsPage />} />
        <Route path="/invoice-pay" element={<InvoicePayPageOuterWrapper />} />
        <Route path="/reporting" element={<ReportingPage />} />
        <Route path="/team" element={<ManageMembersPage />} />
        <Route path="/payrolls">
          <Route index path="*" element={<PayrollPage />} />
        </Route>
        <Route path="/integrations">
          <Route index element={<IntegrationsPageWrapper />} />
          <Route path=":oauthProvider" element={<IntegrationsPageWrapper />} />
        </Route>
      </Route>

      {/* Protected settings routes */}
      <Route path="/settings" element={<ProtectedRoute element={<Layout />} />}>
        <Route path="organisation" element={<OrganisationSettingsPage />} />
      </Route>

      {/* TODO: https://linear.app/seapoint/issue/TENG-2918/update-app-routes-to-have-redirect-to-dashboard-when-ga*/}
      {/* Redirect root to dashboard */}
      <Route path="/" element={<Navigate to="/transactions" replace />} />

      {/* TPP consent route */}
      <Route path="/tpp" element={<ProtectedRoute element={<></>} />}>
        <Route path="uk/consent" element={<TPPConsentPage adapter={TPPAdapters.TELL_MONEY_UK} />} />
        <Route path="eu/consent" element={<TPPConsentPage adapter={TPPAdapters.TELL_MONEY_EU} />} />
        <Route path="consent/result" element={<ConsentResultPage />} />
      </Route>

      <Route path="/reachout" element={<ReachoutPage />} />

      {/* Cards test page for secure card details */}
      <Route path="/cards-test" element={<ProtectedRoute element={<CardsTestPage />} />} />

      {/* Redirect old /dashboard/* routes to new paths without /dashboard prefix */}
      <Route path="/dashboard/*" element={<DashboardRedirect />} />

      {/* Catch-all route for unknown paths */}
      <Route path="*" element={<NoMatch />} />
    </Routes>
  );
};
